export { default } from "./filled-star";
